import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=6bbc506e&scoped=true&"
import script from "./Press.vue?vue&type=script&lang=js&"
export * from "./Press.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc506e",
  null
  
)

export default component.exports